import red from '@mui/material/colors/red'

import { createTheme } from '@mui/material/styles'

// A custom theme for this app
const theme = createTheme({
    palette: {
        primary: {
            main: '#a5c3a7',
        },
        secondary: {
            main: '#96c590',
        },
        error: {
            main: red.A400,
        },
        background: {
            default: '#f5f5f5',
        },
    },
})

export default theme
